import React from 'react'

const DeviceUsage = (props) => {
    const { name = 'Device', width = 0, className = '', count = '' } = props
    return (
        <div className={className ? `device ${className}` : 'device'} style={{ width: width + '%' }} >
            <span style={{ color: 'black' }} >{name} </span>
            <span style={{ color: 'black' }}> {count}</span>
        </div>
    )
}

export default DeviceUsage